import Region from 'ondemand/types/Region';
import {createFetchListActions} from 'common/actions/utils';
import OndemandApi from 'common/api/OndemandApi';


export const {
  fetchRegionsIfNeeded,
} = createFetchListActions({
  name: 'region',
  DataType: Region,
  keys: ['agencyId'],
  api: new OndemandApi(),
  idProp: 'regionId',
});



// WEBPACK FOOTER //
// ./src/ondemand/actions/region.js